import type { GenericParameters } from "~/core/models/GenericParameters.type";
import LxcError from "~/core/models/LxcError.class";
import type { GroupUserDto } from "~/modules/user/models/GroupUserDto.interface";
import userGroupService from "~/modules/user/services/userGroup.service";

export function useCreateUserGroup({ organizationCode }: GenericParameters) {
  const service =
    userGroupService.createOrganizationUserGroup.bind(userGroupService);

  const isLoading = ref<boolean>(false);
  const error = ref<LxcError | null>(null);

  async function createUserGroup(userGroup: GroupUserDto): Promise<void> {
    isLoading.value = true;
    error.value = null;
    if (!organizationCode) {
      throw new Error("Organization code is required");
    }
    const response = await service(organizationCode, userGroup);

    if (LxcError.check(response)) {
      error.value = response;
    }

    isLoading.value = false;
  }

  return {
    createUserGroup,
    error,
    isLoading,
  };
}
